import React, { ReactElement, useEffect, useState } from 'react';
import { TextLink, Button, Text, theme } from '@dls/web';
import { Icon as AssetIcon } from '@dls/assets/icons';
import { OrderSummaryV2 } from '@common-modules/shopping-cart';
import SEO from '../components/SEO';

const generateIppData = (data = {}) => {
  const ippData = data;

  if (Object.keys(ippData).length > 0) {
    ippData.item.dataSource = ippData.item.dataSource.map(item => {
      if (item.title === 'Doorstep delivery') {
        return { ...item, action: <TextLink>Change</TextLink> };
      } else if (item.type === 'link') {
        return {
          ...item,
          icon: (
            <AssetIcon
              size={26}
              name="discount"
              color={theme.main.colours.secondary.d1}
            />
          ),
          content: (
            <AssetIcon
              size={26}
              name="arrow_down"
              color={theme.main.colours.secondary.d1}
            />
          )
        };
      }
      if (item.group) {
        item.dataSource = item.dataSource.map(itm => {
          if (itm.type === 'strikeThrough') {
            itm.content = (
              <Text
                type="body"
                color={theme.main.colours.tertiary.l3}
                strikeThrough
              >
                {itm.content}
              </Text>
            );
          }
          return itm;
        });
      }
      return item;
    });

    ippData.checkout.action = [
      <Button fullWidth type="primary">
        Proceed
      </Button>
    ];

    ippData.checkout.dataSource = ippData.checkout.dataSource.map(item => {
      if (item.content === 'YOU SAVE $40') {
        return {
          ...item,
          content: (
            <Text
              type="smallBody"
              color={theme.main.colours.primary.base}
              fontWeight="bold"
            >
              {item.content}
            </Text>
          )
        };
      } else if (item.title === 'Payable today') {
        return {
          ...item,
          content: <Text type="sectionTitle02">{item.content}</Text>
        };
      } else if (item.title === '(GST-inclusive)') {
        return {
          ...item,
          content: (
            <Text
              type="body"
              strikeThrough
              color={theme.main.colours.tertiary.l3}
            >
              {item.content}
            </Text>
          )
        };
      }

      return item;
    });
  }

  return ippData;
};

export const IPPOrderSummaryPage: React.FC = (): ReactElement => {
  const [data, setData] = useState({});

  useEffect(() => {
    const apiFetch = async () => {
      const result = await fetch(
        `${process.env.GATSBY_MOCK_SERVER_URL}/ipp-order-summary`
      ).then(res => res.json());
      setData(result);
    };
    apiFetch();
  }, []);

  return (
    <>
      <SEO description="" title="IPP Order Summary" />
      <OrderSummaryV2 data={generateIppData(data)} />
    </>
  );
};

export default IPPOrderSummaryPage;
